// extracted by mini-css-extract-plugin
module.exports = {"main_content_container":"ProjectMasterPlanePage_main_content_container__10-jB"};